import * as tslib_1 from "tslib";
import * as React from 'react';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import MailListActionHeaderThirdRow from 'owa-mail-list-view/lib/components/listHeaders/MailListActionHeaderThirdRow';
import MailListFolderHeaderSecondRowContent from 'owa-mail-list-view/lib/components/listHeaders/MailListFolderHeaderSecondRowContent';
import MailListHeader from 'owa-mail-list-view/lib/components/MailListHeader';
import MailListHeaderSecondRowTextContent from 'owa-mail-list-view/lib/components/listHeaders/MailListHeaderSecondRowTextContent';
import MailListHeaderSelectionRowContent from 'owa-mail-list-view/lib/components/listHeaders/MailListHeaderSelectionRowContent';
import strings from 'owa-strings/owa-mail-strings';
import { isDeletedItemsFolderFromAnyMailbox } from 'owa-mail-store';
import { BulkActionProgressBar } from 'owa-mail-bulk-action-view';
import { CategoryIcon } from 'owa-categories';
import { format } from 'owa-strings';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { MailListCategoryHeaderSecondRowContent } from 'owa-mail-category-view';
import { PersonaHeader, MultiPersonaHeader } from 'owa-people-persona-header-view';
import { selectFolder } from 'owa-mail-folder-forest-actions';
import { store as bulkActionStore } from 'owa-bulk-action-store';
import { listViewStore } from 'owa-mail-list-store';
import { SearchHeaderFirstRowContent } from 'owa-mail-search-view';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { getHeaderPersonaData } from '../selectors/getHeaderPersonaData';
import { getMultiPersonaHeaderData } from '../selectors/getMultiPersonaHeaderData';
import shouldShowCategoryHeader from '../selectors/shouldShowCategoryHeader';
import { isFolderUnderArchiveRoot } from 'owa-mail-store';
import { shouldShowSinglePersonaHeader } from '../selectors/shouldShowSinglePersonaHeader';
import { shouldShowMultiPersonaHeader } from '../selectors/shouldShowMultiPersonaHeader';
import folderStore, { PRIMARY_DUMPSTER_DISTINGUISHED_ID, ARCHIVE_DUMPSTER_DISTINGUISHED_ID, PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID, ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID, } from 'owa-folders';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
/**
 * Gets the appropriate mail list header based on the tableView properties
 * @param tableViewId tableView id
 * @return returns a header component
 */
export default function getMailListHeader(tableViewId) {
    var e_1, _a;
    var tableView = listViewStore.tableViews.get(tableViewId);
    var selectedNode = getSelectedNode();
    var isSearchTable = tableView.tableQuery.type == 1 /* Search */;
    if (tableView.tableQuery.type == 2 /* Group */) {
        // TODO 89653: Add Group Header with Filters
        return null;
    }
    var shouldShowSelectionHeader = getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
        ReadingPanePosition.Off &&
        ((tableView.isInCheckedMode && tableView.selectedRowKeys.size > 0) ||
            tableView.isInVirtualSelectAllMode);
    if (shouldShowMultiPersonaHeader(isSearchTable, tableViewId, selectedNode)) {
        var multiHeaderData = getMultiPersonaHeaderData(tableViewId, selectedNode);
        return (React.createElement(MultiPersonaHeader, { displayName: multiHeaderData.displayName, personas: multiHeaderData.personas, favoriteActionSource: 'MultiPersonaHeader', favoriteId: multiHeaderData.favoriteId, pdlId: multiHeaderData.pdlId, hideFilter: isSearchTable }));
    }
    if (shouldShowSinglePersonaHeader(isSearchTable, tableViewId, selectedNode)) {
        var headerPersona = getHeaderPersonaData(isSearchTable, tableViewId, selectedNode);
        // VSO 23726 - Refactor Persona header to use MailListHeader and only have custom content defined as components
        return (React.createElement(PersonaHeader, { hideFilter: isSearchTable, personaId: headerPersona.personaId, personEmail: headerPersona.email, personName: headerPersona.displayName, favoriteActionSource: headerPersona.origin, mailboxType: headerPersona.mailboxType }));
    }
    var renderFirstRow = null;
    var renderSecondRowContent = null;
    var renderThirdRow = null;
    var renderBulkActionProgressBar = null;
    var renderSecondRowIcon = null;
    var shouldShowFilterMenu = true;
    var filterMenuSource = 'MailFilterMenu';
    var shouldShowSearchHeader = isSearchTable || selectedNode.type == 3 /* Search */;
    // We pass categoryHeaderData so that we do not run the same logic twice
    // first to determine if the header should be shown and next to determine the name of the category
    var categoryHeaderData = { categoryName: null };
    if (shouldShowCategoryHeader(tableView, categoryHeaderData)) {
        shouldShowFilterMenu = false;
        var categoryName_1 = categoryHeaderData.categoryName;
        renderSecondRowIcon = function (iconCssClass) {
            return React.createElement(CategoryIcon, {
                categoryName: categoryName_1,
                iconClassName: iconCssClass,
            }, null /* children */);
        };
        if (shouldShowSelectionHeader) {
            renderSecondRowContent = getSelectionHeader(tableView);
        }
        else {
            renderSecondRowContent = function (containerCssClass) {
                return React.createElement(MailListCategoryHeaderSecondRowContent, {
                    key: categoryName_1,
                    categoryName: categoryName_1,
                    containerCssClass: containerCssClass,
                }, null /* children */);
            };
        }
    }
    else if (shouldShowSearchHeader) {
        shouldShowFilterMenu = false;
        renderFirstRow = function (mailListFirstRowCssClass) {
            return React.createElement(SearchHeaderFirstRowContent, {
                className: mailListFirstRowCssClass,
            });
        };
        if (shouldShowSelectionHeader) {
            renderSecondRowContent = getSelectionHeader(tableView);
        }
        else {
            renderSecondRowContent = function (containerCssClass) {
                var searchScope = tableView.tableQuery.searchScope;
                var searchResultHeaderText = searchScope && searchScope.kind == "ArchiveMailbox" /* ArchiveMailbox */
                    ? strings.searchResultsFromArchive
                    : strings.searchResults;
                return React.createElement(MailListHeaderSecondRowTextContent, { text: searchResultHeaderText, containerCssClass: containerCssClass }, null /* children */);
            };
        }
    }
    else {
        var folderId = tableView.tableQuery.folderId;
        var isDeletedTable = isDeletedItemsFolderFromAnyMailbox(folderId);
        var isJunkEmailFolder = folderIdToName(folderId) == 'junkemail';
        var dumpsterFolderDistinguishedId_1;
        var dumpsterFolderId_1;
        var deletedItemsFolderDistinguishedId_1;
        var treeType = void 0;
        if (isFolderUnderArchiveRoot(folderId)) {
            dumpsterFolderDistinguishedId_1 = ARCHIVE_DUMPSTER_DISTINGUISHED_ID;
            dumpsterFolderId_1 = folderNameToId(ARCHIVE_DUMPSTER_DISTINGUISHED_ID);
            treeType = 'archiveFolderTree';
            deletedItemsFolderDistinguishedId_1 = ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID;
        }
        else {
            dumpsterFolderDistinguishedId_1 = PRIMARY_DUMPSTER_DISTINGUISHED_ID;
            dumpsterFolderId_1 = folderNameToId(PRIMARY_DUMPSTER_DISTINGUISHED_ID);
            treeType = 'primaryFolderTree';
            deletedItemsFolderDistinguishedId_1 = PRIMARY_DELETED_ITEMS_DISTINGUISHED_ID;
        }
        var isDumpsterTable = dumpsterFolderId_1 === folderId;
        shouldShowFilterMenu = !isDumpsterTable;
        if (isJunkEmailFolder) {
            var retentionPolicyTags = getUserConfiguration().RetentionPolicyTags;
            var retentionDays_1 = 30; // Default
            try {
                for (var retentionPolicyTags_1 = tslib_1.__values(retentionPolicyTags), retentionPolicyTags_1_1 = retentionPolicyTags_1.next(); !retentionPolicyTags_1_1.done; retentionPolicyTags_1_1 = retentionPolicyTags_1.next()) {
                    var policy = retentionPolicyTags_1_1.value;
                    if (policy.DisplayName == 'JunkMail') {
                        retentionDays_1 = policy.RetentionPeriod;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (retentionPolicyTags_1_1 && !retentionPolicyTags_1_1.done && (_a = retentionPolicyTags_1.return)) _a.call(retentionPolicyTags_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            renderThirdRow = function (mailListThirdRowCssClass) {
                return React.createElement(MailListActionHeaderThirdRow, {
                    containerCssClass: mailListThirdRowCssClass,
                    text: format(strings.junkMailHeader, retentionDays_1),
                }, null /* children */);
            };
        }
        // TODO: VSO bug number 34640
        // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/34640
        if (isDeletedTable) {
            var dumpsterTotalCount = folderStore.folderTable.get(dumpsterFolderId_1).TotalCount;
            var dumpsterLinkNumItemsString = void 0;
            var showLoadingSpinner_1 = false;
            if (dumpsterTotalCount < 0) {
                showLoadingSpinner_1 = true;
            }
            else if (dumpsterTotalCount === 1) {
                dumpsterLinkNumItemsString = format(strings.singleItem, dumpsterTotalCount);
            }
            else {
                dumpsterLinkNumItemsString = format(strings.noneOrMultipleItems, dumpsterTotalCount);
            }
            var dumpsterLinkString_1 = strings.recoverItemsDeletedFromThisFolder;
            // Currently, we don not show the number for archive mailbox because
            // the count gets updated by hierarchy notifications
            if (!showLoadingSpinner_1 && treeType === 'primaryFolderTree') {
                // TODO: Task 26546: [RTL] Go to recoverable items in deleted items folder string needs to be RTL friendly
                dumpsterLinkString_1 += ' (' + dumpsterLinkNumItemsString + ')';
            }
            renderThirdRow = function (mailListThirdRowCssClass) {
                return React.createElement(MailListActionHeaderThirdRow, {
                    containerCssClass: mailListThirdRowCssClass,
                    text: dumpsterLinkString_1,
                    onClick: goToDumpster,
                    showLoadingSpinner: showLoadingSpinner_1,
                    distinguishedFolderId: dumpsterFolderDistinguishedId_1,
                }, null /* children */);
            };
        }
        else if (isDumpsterTable) {
            renderSecondRowContent = function (containerCssClass) {
                return React.createElement(MailListHeaderSecondRowTextContent, {
                    text: folderStore.folderTable.get(dumpsterFolderId_1).DisplayName,
                    containerCssClass: containerCssClass,
                }, null /* children */);
            };
            renderThirdRow = function (mailListThirdRowCssClass) {
                return React.createElement(MailListActionHeaderThirdRow, {
                    containerCssClass: mailListThirdRowCssClass,
                    text: strings.goBackToDeletedItems,
                    onClick: goToDeletedItems,
                    showBackArrow: true,
                    distinguishedFolderId: deletedItemsFolderDistinguishedId_1,
                }, null /* children */);
            };
        }
        // This checks whether the second row has been set. This is possible if:
        // The dumpster flag is off OR
        // We are in a non-dumpster folder
        if (!renderSecondRowContent) {
            if (shouldShowSelectionHeader) {
                renderSecondRowContent = getSelectionHeader(tableView);
            }
            else {
                renderSecondRowContent = function (containerCssClass) {
                    return React.createElement(MailListFolderHeaderSecondRowContent, { tableViewId: tableViewId, containerCssClass: containerCssClass }, null /* children */);
                };
            }
        }
        // Show bulk action progress bar if flag is enabled and there is a bulk operation running on that folder
        if (isMailFeatureEnabled('tri-bulkActionNotification') &&
            bulkActionStore.bulkActionInformationMap.has(folderId)) {
            renderBulkActionProgressBar = function () {
                return React.createElement(BulkActionProgressBar);
            };
        }
    }
    return React.createElement(MailListHeader, {
        tableViewId: tableViewId,
        shouldShowFilterMenu: shouldShowFilterMenu,
        filterMenuSource: filterMenuSource,
        renderFirstRow: renderFirstRow,
        renderSecondRowIcon: renderSecondRowIcon,
        renderSecondRowCustomContent: renderSecondRowContent,
        renderThirdRow: renderThirdRow,
        renderBulkActionProgressBar: renderBulkActionProgressBar,
    }, null /* children */);
}
function goToDumpster(event, distinguishedFolderId) {
    var treeType = distinguishedFolderId === ARCHIVE_DUMPSTER_DISTINGUISHED_ID
        ? 'archiveFolderTree'
        : 'primaryFolderTree';
    selectFolder(folderNameToId(distinguishedFolderId), treeType);
}
function goToDeletedItems(event, distinguishedFolderId) {
    var treeType = distinguishedFolderId === ARCHIVE_DELETED_ITEMS_DISTINGUISHED_ID
        ? 'archiveFolderTree'
        : 'primaryFolderTree';
    selectFolder(folderNameToId(distinguishedFolderId), treeType);
}
function getSelectionHeader(tableView) {
    return function (containerCssClass) {
        return React.createElement(MailListHeaderSelectionRowContent, {
            numChecked: tableView.selectedRowKeys.size,
            containerCssClass: containerCssClass,
            tableViewId: tableView.id,
        }, null /* children */);
    };
}
//# sourceMappingURL=getMailListHeader.js.map